import 'slick-carousel';

class KachelSlider {
    constructor($el) {
        this.$el = $el;
        this.init();
    }

    init = () => {
        this.slick = this.$el.slick({
            slidesToShow: 3.4,
            infinite: false,
            arrows: true,  
            prevArrow: '.slick-prev',  
            nextArrow: '.slick-next',  


            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2.2,

                  }
                },
                {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 1.2,
  
                    }
                  },
            ]
        });
    }
}

export default KachelSlider;
